import keys, {keyCodes} from "@legacy/helpers/constants/keyboard";

const keyboard = keys;

export const hasKey = keyCode => keyCodes.includes(keyCode);

export default keyboard;